import React, { useEffect, useState } from 'react';
import './index.css';
import apiurl from './apiurl';
import axios from 'axios';
import Select from 'react-select'
import { Klasyfikacje, KontrahenciSearch, SloZadan } from './RejestrPopUp';
import update from 'immutability-helper';
import swal from 'sweetalert';




export default class RejestrForm1 extends React.Component {

  constructor(props) {

    super();    

    this.state = {

      token: sessionStorage.getItem('token'),

      loadKontr: false,

      idWydz: '',

      cruCzy: false,

      checkForm: true,

      klasyfikaceArray: [],
      ponadPlan: false,

    }



    this.getSloZam();

    this.getSloRodzZam();

    this.getTrybP();

    this.getWydzialy(props.rok);

    this.getDokTyp();
    this.getDokWZP();



  }







getSloZam = () => {

  axios

    .get(apiurl+"api/v2/SloZam ", { headers: { 'Authorization' : "Bearer " + this.state.token }})

    .then(response => {

      let data = response.data.map( data => ({ value: data.iD_SLOZAM, label: data.nazwa}));

      this.setState({ SloZamData: data })

    }

    )

    .catch(error => {console.log(error)});

}



getSloRodzZam = () => {

  axios

    .get(apiurl+"api/v2/SloRodzZam ", { headers: { 'Authorization' : "Bearer " + this.state.token }})

    .then(response => {

      let data = response.data.map( data => ({ value: data.iD_RODZ_ZAM, label: data.nazwa}));

      this.setState({ rodzZamData: data })

    }

    )

    .catch(error => {console.log(error)});

}



getDokTyp = () => {

  axios

    .get(apiurl+"api/v2/DokTyp", { headers: { 'Authorization' : "Bearer " + this.state.token }})

    .then(response => {

      let data = response.data.map( data => ({ value: data.kod, label: data.doktyp}));

      this.setState({ dokTypData: data })

    }

    )

    .catch(error => {console.log('error')});

}



getTrybP = () => {

  axios

    .get(apiurl+"api/v2/TrybP", { headers: { 'Authorization' : "Bearer " + this.state.token }})

    .then(response => {

      this.setState({ trybPData: response.data })

    }

    )

    .catch(error => {console.log('error')});

}





getRachunki = (value) => {

  axios

    .get(apiurl+"api/v2/Rachunki", { params: { idKontrah: value }, headers: { 'Authorization' : "Bearer " + this.state.token }})

    .then(response => {

      let data = response.data.map( data => ({ value: data.iD_RACH, label: data.konto}));

      this.setState({ rachunkiData: data })

    }

    )

    .catch(error => {console.log('error')});

}



getWydzialy = (value) => {

  axios

    .get(apiurl+"api/v2/WydzialyOper", { params: { rok: value}, headers: { 'Authorization' : "Bearer " + this.state.token }})

    .then(response => {

      let data = response.data.map( data => ({ value: data.iD_WYDZIALU, label: data.nazwa}));

      this.setState({ wydzialyData: data })

    }

    )

    .catch(error => {console.log('error')});

}

getDokWZP = () => {
  axios
    .get(apiurl+"api/v2/DokWZP", { headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response => {
      let data = response.data.map( data => ({ value: data.kod, label: data.dokwzp}));
      this.setState({ dokWZPData: data })
    })
    .catch(error => {console.log('error')});
}



onChangeKlasyfikacje = (value) => {

  this.setState({ klasyfikaceArray : value})

}



postForm = (e) => {

  e.preventDefault();

  axios.post(apiurl+"api/v2/RejestrUmow ",

  {

    kodJedn: this.props.kodJedn,

    idWydzialu: this.state.idWydzial,

    rok: this.props.rok,

    rokKlasyfikacji: 0,

    idZadania: this.state.idZadania,

    numer: this.state.nrUmowy,

    nrKontrah: this.state.idKontr,
    
    idRachBank: this.state.rachunek,

    tresc: "string",

    kwota: this.state.kwotaUmo,

    dataDok: this.state.dataDok,

    dataReal: this.state.dataRealod,

    idTrybP: this.state.trybP,

    dataRealOd: this.state.dataRealdo,

    kwotaVat: this.state.kwotaVAT,

    idCPV: this.state.CPVid,

    jReal: this.state.odpow,

    idSloZam: this.state.sloZam,

    trescDluga: this.state.trescDluga,

    nrUmowy: this.state.nrUmowy,

    podpis: this.state.podzlece,

    idRodzZam: this.state.przedZam,

    fvDni: this.state.dniFVAT,

    miejsceZawarcia: this.state.miejsceZaw,

    podpisWyk: this.state.podwyko,

    finansowanie: this.state.finansowanie,

    cruCzy: this.state.cruCzy,

    klasyfikacje: this.state.klasyfikaceArray,

    typDok: this.state.dokTyp,

    check: this.state.checkForm,

  },

  {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })

  .then(res => {

    this.setState({ savesuccess: true, saveload: true  });
    if(this.state.checkForm) { this.setState({ checkForm: false, ponadPlan: res.data.CzyPrzekracza })}
    else { this.setState({ checkForm: true }); swal('Zapisano.')}
  })

  .catch(error => {

    alert(error.response.data)
    this.setState({ checkForm: true })
  });

}

onChange = (e) => { this.setState({ [e.target.name]: e.target.value })}

onChangeKontr = (value) => {

  this.setState({ idKontr: value });
  this.getRachunki(value);

}

onChangeCPV = (value) => { this.setState({ CPVid: value })}

onChangeZadania = (value) => { this.setState({ idZadania: value }) }

powrotDoEdycji = (e) => {
  e.preventDefault();
  this.setState({ checkForm : true })
}

render() {

const { ponadPlan, SloZamData, rodzZamData, trybPData, idKontr, rachunkiData, idWydzial, wydzialyData, checkForm, dokTypData, dokWZPData  } = this.state;
const { kodJedn, rok } = this.props;

return (

<React.Fragment>

<form className='d-flex form-control flex-column w-100 h-100 p-3' onSubmit={(e) => (this.postForm(e))}>
  <div className='d-flex flex-row w-100 mb-3'>
    <div class="form-group m-1">

      <label for="dokTyp">Typ dokumentu</label>

      {dokTypData ? (<Select name="form-field-name" options={dokTypData} isDisabled={!checkForm} placeholder="Wybierz..." class="form-control" id="dokTyp"  name="dokTyp" label onChange={e => this.setState({dokTyp: e.value})}/>) : null }   

    </div>

    <div class="form-group m-1">

      <label for="idWydzial">Komórka organizacyjna</label>

      {wydzialyData ? (<Select name="form-field-name" options={wydzialyData} isDisabled={!checkForm} placeholder="Wybierz..." class="form-control" id="idWydzial"  name="idWydzial" label onChange={e => this.setState({idWydzial: e.value})}></Select>) : null }   

    </div>

    {idWydzial && kodJedn && checkForm ? (<>
      <div class="form-group m-1">
      <label for="nrWniosku">ID Zadania</label>
      <input type="text" class="form-control" id="idZadania" value={this.state.idZadania} disabled={!checkForm}  placeholder="ID Zadania" name="idZadania" label onChange={(e) => (this.onChange(e))}></input>
      </div>
      <button type="button" className='btn btn-primary btn-sm m-1'  data-toggle="modal" data-target="#SloZadanModal">...</button>
      </>) : (<div class="form-group m-1">
      <label for="nrWniosku">ID Zadania</label>
      <input type="text" class="form-control" id="idZadania"   placeholder="Wybierz wydział" name="idZadania" label disabled></input>
      </div>) }


    <button type="button" className='btn btn-primary btn-sm m-1 ml-auto' disabled={!checkForm} data-toggle="modal" data-target="#trescDlugaModal">Treść długa</button>

    <button type="button" className='btn btn-primary btn-sm m-1 ml-auto' disabled={!checkForm} data-toggle="modal" data-target="#finansowanieModal">Finansowanie</button>

  </div>

  <div className='d-flex flex-row w-100'>

    <div className='d-flex flex-column'>

      <div class="form-group m-1">

        <label for="nrWniosku">Numer wniosku</label>

        <input type="text" class="form-control" disabled={!checkForm} id="nrWniosku"  placeholder="Numer wniosku" name="nrWniosku" label onChange={(e) => (this.onChange(e))}></input>

      </div>

      <div class="form-group m-1">

        <label for="nrUmowy">Numer umowy</label>

        <input type="text" class="form-control" disabled={!checkForm} id="nrUmowy" required placeholder="Numer umowy" name="nrUmowy" label onChange={(e) => (this.onChange(e))}></input>

      </div>

      <label for="nrRachunku">Numer kontrahenta</label>
      <div className='d-flex flex-row justify-content-center align-items-center'>
        <input type="text" class="form-control" id="nrKontr" disabled={!checkForm} value={idKontr} placeholder="Numer kontrahenta" name="nrKontr" label onChange={(e) => (this.onChange(e))}></input>
        <button type="button" className='btn btn-primary btn-sm m-1' disabled={!checkForm} data-toggle="modal" data-target="#kontrahenciModal"><PersonIcon /></button>
      </div>


      {idKontr ? (<div class="form-group m-1">

        <label for="nrRachunku">Numer rachunku</label>

        {rachunkiData ? (<Select name="form-field-name" isDisabled={!checkForm} options={rachunkiData} placeholder="Wybierz..." class="form-control" id="rachunek"  name="rachunek" label onChange={e => this.setState({rachunek: e.value})}/>) : null }        

      </div>) :  (<div class="form-group m-1">

        <label for="nrRachunku">Numer rachunku</label>

        <input type="text" class="form-control" id="nrRachunku" disabled={!checkForm}  placeholder="Numer rachunku" name="nrRachunku" label disabled></input>

      </div>)}

      <div className='form-row'>

        <div class="form-group m-1">

          <label for="dataDok">Data dokumentu</label>

          <input type="date" class="form-control" id="dataDok" disabled={!checkForm} placeholder="Data dokumentu" name="dataDok" label onChange={(e) => (this.onChange(e))}></input>

        </div>

        <div class="form-group m-1">

          <label for="dataDok">Data realizacji od</label>

          <input type="date" class="form-control" id="dataRealod" disabled={!checkForm} placeholder="Data realizacji od" name="dataRealod" label onChange={(e) => (this.onChange(e))}></input>

        </div>

        <div class="form-group m-1">

          <label for="dataDok">Data realizacji do</label>

          <input type="date" class="form-control" id="dataRealdo" disabled={!checkForm} placeholder="Data realizacji do" name="dataDok" label onChange={(e) => (this.onChange(e))}></input>

        </div>

      </div>

      <div class="form-group m-1">

        <label for="miejsceZaw">Miejsce zawarcia</label>

        <input type="text" class="form-control" id="miejsceZaw" disabled={!checkForm} placeholder="Miejsce zawarcia" name="miejsceZaw" label onChange={(e) => (this.onChange(e))}></input>

      </div>

      <div className='form-row'>

        <div class="form-group m-1">

          <label for="kwotaUmo">Kwota umowy</label>

          <input type="number" class="form-control" id="kwotaUmo" disabled={!checkForm} placeholder="Kwota umowy" name="kwotaUmo" label onChange={(e) => (this.onChange(e))}></input>

        </div>

        <div class="form-group m-1">

          <label for="kwotaVAT">w tym VAT</label>

        <input type="number" class="form-control" id="kwotaVAT" disabled={!checkForm} placeholder="w tym VAT" name="kwotaVAT" label onChange={(e) => (this.onChange(e))}></input>

        </div>

      </div>

    </div>

    <div className='d-flex flex-column'>

      <div class="form-group m-1">

        <label for="kwotaVAT">pozycja rejestru</label>

        <input type="text" class="form-control" id="kwotaVAT" disabled={!checkForm}  name="kwotaVAT" label onChange={(e) => (this.onChange(e))}></input>

      </div>

      <div class="d-flex flex-column m-1">

        <InputCPV disabled={!checkForm} onChangeCPV={this.onChangeCPV} />

      </div>

      <div class="form-group m-1">

        <label for="sloZam">Slownik zamówień</label>

        {SloZamData ? (<Select name="form-field-name" options={SloZamData} isDisabled={!checkForm} placeholder="Wybierz..." class="form-control" id="sloZam"  name="sloZam" label onChange={e => this.setState({sloZam: e.value})}/>) : null }        

      </div>

      <div class="form-group m-1">

        <label for="odpow">Jednostka/osoba odpowiedzialna/przekazująca</label>

        <input type="text" class="form-control" id="odpow" disabled={!checkForm} placeholder="odpowiedzialna" name="odpow" label onChange={(e) => (this.onChange(e))}></input>

      </div>

      <div class="form-group m-1">

        <label for="przedZam">Przedmiot zamówienia</label>

        {rodzZamData ? (<Select name="form-field-name" isDisabled={!checkForm} options={rodzZamData} placeholder="Wybierz..." class="form-control" id="przedZam"  name="przedZam" label onChange={e => this.setState({przedZam: e.value})}/>) : null }        

      </div>

      <div class="form-group m-1">

        <label for="temat">Temat</label>

        <input type="text" class="form-control" id="temat" disabled={!checkForm} placeholder="Temat" name="temat" label onChange={(e) => (this.onChange(e))}></input>

      </div>

      <div class="form-check m-2">

        <input class="form-check-input" type="checkbox" disabled={!checkForm} value={this.state.cruCzy} id="CRU" onClick={() => (this.setState({ cruCzy: !this.state.cruCzy }))}></input>

        <label class="form-check-label" for="CRU">Podlega CRU</label>

      </div>

    </div>

    <div className='d-flex flex-column'>

      <div class="form-group m-1">

        <label for="podzlece">Podpisana przez (zleceniodawca)</label>

        <input type="text" class="form-control" id="podzlece" disabled={!checkForm} placeholder="Podpisana przez" name="podzlece" label onChange={(e) => (this.onChange(e))}></input>

      </div>

      <div class="form-group m-1">

        <label for="podwyko">Podpisana przez (wykonawca)</label>

        <input type="text" class="form-control" id="podwyko" disabled={!checkForm} placeholder="Podpisana przez" name="podwyko" label onChange={(e) => (this.onChange(e))}></input>

      </div>

      <div class="form-group m-1">

        <label for="dniFVAT">Faktury płatne w ciągu dni:</label>

        <input type="number" class="form-control" id="dniFVAT" disabled={!checkForm} value={this.state.dniFVAT}  placeholder="Dni" step="1" min="1" name="dniFVAT" label onChange={(e) => (this.onChange(e))}></input>

      </div>

    </div>

  </div>

  <div className='d-flex flex-row w-100'>

    <div class="form-group m-1 w-50">

      <label for="trybP">Tryb postępowania</label>

      {trybPData ? (<select className='form-control' id="trybP" disabled={!checkForm} name="trybP" required onChange={(e) => (this.onChange(e))}>
        <option disabled hidden selected>Wybierz...</option>
        {trybPData.map((dane, idx) => {

          return <option key={idx} value={dane.iD_TRYBP}>{dane.opis}</option>

        })}

      </select>) : null}

    </div>

  </div>

  <div className='d-flex flex-column w-100'>

    <KlasyfikacjaPanel disabled={!checkForm} rok={rok} idWydzial={idWydzial} kodJedn={kodJedn} dokWZPData={dokWZPData} onChangeKlasyfikacje={this.onChangeKlasyfikacje} />

  </div>

  {!checkForm ? (<>{ponadPlan ? (<div className='d-flex flex-row w-100 mt-2 mb-2'>
    <div class="alert alert-danger ml-auto" role="alert">
      Formularz niepoprawny
    </div>
  </div>) : (<div className='d-flex flex-row w-100'>
    <div class="alert alert-success ml-auto" role="alert">
      Formularz sprawdzony poprawnie
    </div>
  </div>) }</>) : null }

  <div className='d-flex flex-row justify-content-end align-items-center'>

    {checkForm ? (<button className='btn btn-primary ml-1' type='submit'>Sprawdź formularz</button>) : (<><button className='btn btn-secondary mr-1' type='button' onClick={(e) => (this.powrotDoEdycji(e))}>Edytuj</button><button className='btn btn-success ml-1' type='submit'>Zapisz</button></>)}

  </div>

</form>



<div class="modal fade" tabindex="-1" id="kontrahenciModal" role="dialog" aria-labelledby="kontrahenciModal" aria-hidden="true">

  <div class="modal-dialog modal-lg">

    <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Kontrahenci</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

     <KontrahenciSearch onChangeKontr={this.onChangeKontr} />

    </div>

  </div>

</div>



{idWydzial && kodJedn  ? (<div class="modal fade" tabindex="-1" id="SloZadanModal" role="dialog" aria-labelledby="SloZadanModal" aria-hidden="true">

  <div class="modal-dialog modal-lg">

    <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Zadania</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

     <SloZadan rok={rok} kodJedn={kodJedn} idWydz={idWydzial} onChangeZadania={this.onChangeZadania} />

    </div>

  </div>

</div>) : null}



<div class="modal fade" tabindex="-1" id="trescDlugaModal" role="dialog" aria-labelledby="trescDlugaModal" aria-hidden="true">

  <div class="modal-dialog modal-lg">
    <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Treść długa</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">

    <textarea type="text" class="form-control" id="trescdluga"   name="trescdluga" label onChange={(e) => (this.onChange(e))}></textarea>

    </div>

    <div class="modal-footer">

    <button type="button" class="btn btn-success" data-dismiss="modal">Zapisz</button>

    </div>

    </div>

  </div>

</div>



<div class="modal fade" tabindex="-1" id="finansowanieModal" role="dialog" aria-labelledby="finansowanieModal" aria-hidden="true">

  <div class="modal-dialog modal-lg">

    <div class="modal-content">

    <div class="modal-header">
      <h5 class="modal-title">Finansowanie</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">

    <textarea type="text" class="form-control" id="finansowanie"   name="finansowanie" label onChange={(e) => (this.onChange(e))}></textarea>

    </div>

    <div class="modal-footer">

    <button type="button" class="btn btn-success" data-dismiss="modal">Zapisz</button>

    </div>

    </div>

  </div>

</div>



</React.Fragment>

);

}

}





// const InputKontrahenci = (props) => {

//   const [loadKontr, setLoading] = useState(false);
//   const [kontrahenciData, setData] = useState();
//   const [idKontr, setID] = useState();
//   const [searchValue, setSearchValue] = useState();
//   const [token, setToken] = useState(sessionStorage.getItem('token'));


//   const searchKontrahenci = (value) => {
//     axios
//       .get(apiurl+"api/v2/Kontrahenci", { params: { search: value}, headers: { 'Authorization' : token }})
//       .then(response => {
//         setData(response.data);
//         setLoading(false);
//       })
//       .catch(error => {console.log('error'); setLoading(false); setData(); });
// }



//   const onChangeSearch = (e) => {
//     setLoading(true);
//     setSearchValue(e.target.value);
//   }



//   useEffect(() => {
//     const timer = setTimeout((e) => { searchKontrahenci(searchValue)}, 1500);
//     return () => clearTimeout(timer);
//   }, [searchValue]);





//   return (<div class="form-group m-1">
//   <label for="nrRachunku">Numer kontrahenta</label>
//   <div className='d-flex flex-row justify-content-center align-items-center'>
//     <input type="text" class="form-control" id="nrKontr" value={searchValue} placeholder="Numer kontrahenta" name="nrKontr" label onChange={(e) => (onChangeSearch(e))}></input>
//     {loadKontr ? (<div class="spinner-border text-primary spinner-border-sm m-1" role="status"><span class="sr-only">Loading...</span></div>) : null }
//     <button type="button" className='btn btn-primary btn-sm m-1' data-toggle="modal" data-target="#kontrahenciModal"><PersonIcon /></button>
//   </div>

//   {kontrahenciData ? (<ul class="list-group" style={{ maxHeight: '150px', overflow: 'auto'}}>

//     {kontrahenciData.map((dataK, idx) => { return (<li class={dataK.kontrahentId === idKontr ? "list-group-item pointer active" : "list-group-item pointer"} key={idx} onClick={() => (setID(dataK.kontrahentId), props.onChangeKontr(dataK.kontrahentId), setData(), setSearchValue(dataK.nazwa))}>{dataK.nazwa}</li>)})}

//   </ul>) : null }

// </div>)

// }



const InputCPV = (props) => {

  const [loadCPV, setLoading] = useState(false);

  const [tooShort, setTooShort] = useState(false);

  const [inputVal, setInputVal] = useState();

  const [idCPV, setIDCPV] = useState();

  const [CPVData, setData] = useState();

  const [search, setSearch] = useState(false);



  const [token, setToken] = useState(sessionStorage.getItem('token'));



  

  

  const searchCPV = (value) => {

    axios

    .get(apiurl+"api/v2/CPV", { params: { search: value }, headers: { 'Authorization' : token }})

    .then(response => {

      setData(response.data);

      setLoading(false);

    })

    .catch(error => {console.log('error'); setLoading(false); setData(); });

  }



  const onChangeSearch = (e) => {

    if(e.target.value.length >= 3) {

      setLoading(true);

      setInputVal(e.target.value);

      setTooShort(false)

    } else {

      setTooShort(true);

      setInputVal(e.target.value);

      setSearch(false)

    }

  }





  useEffect(() => {

    if(search) {

    const timer = setTimeout((e) => { searchCPV(inputVal)}, 1500);

    return () => clearTimeout(timer);

    }

  }, [inputVal]);





  return (<div class="form-group m-1">

  <label for="CPV">CPV {tooShort ? (<span className='text-danger'>Min. 3 znaki</span>) : null}</label>

  <div className='d-flex flex-row justify-content-center align-items-center'>

    <input type="text" class="form-control" id="CPV" disabled={props.disabled} value={inputVal} placeholder="Wyszukaj..." name="CPV" label onChange={(e) => (onChangeSearch(e), setSearch(true))}></input>

    {loadCPV ? (<div class="spinner-border text-primary spinner-border-sm m-1" role="status"><span class="sr-only">Loading...</span></div>) : null }

  </div>

  {CPVData ? (<ul class="list-group" style={{ maxHeight: '150px', overflow: 'auto'}}>

    {CPVData.map((dataK, idx) => { return (<li class={dataK.iD_CPV === idCPV ? "list-group-item pointer active" : "list-group-item pointer"} key={idx} onClick={() => (setIDCPV(dataK.iD_CPV), setSearch(false), setInputVal(dataK.nazwa), setData(), props.onChangeCPV(dataK.iD_CPV))}>{dataK.nazwa}</li>)})}

  </ul>) : null }

</div>)

}







const KlasyfikacjaPanel = (props) => {

  const [dataArr, setDataArr] = useState([{

    dzial: 0,

    rozdzial: 0,

    paragraf: 0,

    pozycja: 0,

    rok: props.rok,

    kwota: 0,

    vat: 0,

    fundSoleck: false,

    klasPozaBudz: false,

    koD_DOKWZP: 0,

  }]);

  const [token, setToken] = useState(sessionStorage.getItem('token'));

  const [lata, setLata] = useState();

  let {idWydzial, kodJedn, rok} = props;







  const addKlasyfikacje = (e) => {

    e.preventDefault();

    const newElement = {

      dzial: 0,

      rozdzial: 0,

      paragraf: 0,

      pozycja: 0,

      rok: props.rok,

      kwota: 0,

      vat: 0,

      fundSoleck: false,

      klasPozaBudz: false,

      koD_DOKWZP: "",

    }

    setDataArr(dataArr => [...dataArr, newElement]);

  }



  const addKlasyfikacjePop = (e, dane) => {

    e.preventDefault();

    const newElement = {

      dzial: dane.dzial,

      rozdzial: dane.rozdzial,

      paragraf: dane.paragraf,

      pozycja: dane.pozycja,

      rok: props.rok,

      kwota: 0,

      vat: 0,

      fundSoleck: false,

      klasPozaBudz: false,

      koD_DOKWZP: "",

    }

    setDataArr(dataArr => [...dataArr, newElement]);

  }

  

  const removeKlasyfikacja = (e, idx) => {

    e.preventDefault();

    setDataArr(dataArr.filter((item, index) => index !== idx));

  }



  const updateKlasydikacja = (e, idx) => {

    e.preventDefault();

    var updatedData = update(dataArr[idx], {[e.target.name]: {$set: e.target.value}}); 

    var newData = update(dataArr, { $splice: [[idx, 1, updatedData]] });

    setDataArr(newData);

  }



  const updateKlasydikacjaCheck = (e, idx, value) => {

    var updatedData = update(dataArr[idx], {[e.target.name]: {$set: value}}); 

    var newData = update(dataArr, { $splice: [[idx, 1, updatedData]] });

    setDataArr(newData);

  }



  const updateKlasydikacjaSelect= (idx, value) => {

    var updatedData = update(dataArr[idx], {rok: {$set: value}}); 

    var newData = update(dataArr, { $splice: [[idx, 1, updatedData]] });

    setDataArr(newData);

  }





  useEffect(() => {

    props.onChangeKlasyfikacje(dataArr)

  }, [dataArr]);





  return (<>

  <div className='d-flex flex-row align-items-center mt-3'>

  <label for="klaysyfikacje">Klasyfikacja</label>

  <button className='btn btn-primary ml-2' disabled={props.disabled} onClick={(e) => (addKlasyfikacje(e))}>+</button>

  {idWydzial && kodJedn  ? (<button type="button" disabled={props.disabled} className='btn btn-primary btn-sm m-1' data-toggle="modal" data-target="#KlasyfikacjeModal">...</button>) : null}

  </div>



  {dataArr.length > 0 ? (<>

  {dataArr.map((dane, idx) => {

    return (<div className='d-flex flex-row m-1 p-1 align-items-center'>

      <input type="number" disabled={props.disabled} class="form-control m-1 col-1" id="dzial" value={dane.dzial} name="dzial" label onChange={(e) => (updateKlasydikacja(e, idx))}></input>

      <input type="number" disabled={props.disabled} class="form-control m-1 col-1" id="rodzial" value={dane.rozdzial} name="rodzial" label onChange={(e) => (updateKlasydikacja(e, idx))}></input>

      <input type="number" disabled={props.disabled} class="form-control m-1 col-1" id="paragraf" value={dane.paragraf} name="paragraf" label onChange={(e) => (updateKlasydikacja(e, idx))}></input>

      <input type="number" disabled={props.disabled} class="form-control m-1 col-1" id="pozycja" value={dane.pozycja} name="pozycja" label onChange={(e) => (updateKlasydikacja(e, idx))}></input>

      {props.dokWZPData ? (<select className='form-control m-1 col-1' disabled={props.disabled} id="koD_DOKWZP" nazwa="koD_DOKWZP" onChange={(e) => (updateKlasydikacja(e, idx))}>
        <option value='null' disabled selected hidden>Wybierz...</option>
        {props.dokWZPData.map((dane, idx) => {
          return (<option value={dane.value} key={idx}>{dane.label}</option>)
        })}
      </select>) : null }        


      <div className='d-flex flex-column'>

        <div class="form-check m-1">

          <input class="form-check-input" disabled={props.disabled} type="checkbox" checked={dane.klasPozaBudz} id="klasPozaBudz" name="klasPozaBudz" onClick={(e) => (updateKlasydikacjaCheck(e, idx, !dane.klasPozaBudz))}></input>

          <label class="form-check-label" for="klasPozaBudz">Klasyfikacja pozabudżetowa</label>

        </div>

        <div class="form-check m-1">

          <input class="form-check-input" disabled={props.disabled} type="checkbox" checked={dane.fundSoleck} id="fundSoleck" name="fundSoleck" onClick={(e) => (updateKlasydikacjaCheck(e, idx, !dane.fundSoleck))}></input>

          <label class="form-check-label" for="fundSoleck">Fundusz sołecki</label>

        </div>

      </div>

      <span>Rok</span>

      <input type="number" disabled={props.disabled} class="form-control m-1 col-1" id="rok"  name="rok" label onChange={(e) => (updateKlasydikacja(e, idx))}></input>

      <span>PLN</span>

      <input type="number" disabled={props.disabled} class="form-control m-1 col-1" id="kwota"  name="pokwotazycja" label onChange={(e) => (updateKlasydikacja(e, idx))}></input>

      <span>w tym VAT</span>

      <input type="number" disabled={props.disabled} class="form-control m-1 col-1" id="vat"  name="vat" label onChange={(e) => (updateKlasydikacja(e, idx))}></input>



      <button className='btn btn-light m-1' disabled={props.disabled} onClick={(e) => (removeKlasyfikacja(e, idx))}><TrashIcon /></button>

    </div>)

  })}

  </>) : null }

  

  {idWydzial && kodJedn  ? (<div class="modal fade" tabindex="-1" id="KlasyfikacjeModal" role="dialog" aria-labelledby="KlasyfikacjeModal" aria-hidden="true">

  <div class="modal-dialog modal-lg">

    <div class="modal-content">

     <Klasyfikacje addKlasyfikacjePop={addKlasyfikacjePop} rok={rok} idWydz={idWydzial} kodJedn={kodJedn} />

    </div>

  </div>

  </div>) : null }





  </>)



}





const PersonIcon = () => {

  return (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-square" viewBox="0 0 16 16">

            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>

            <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1v-1c0-1-1-4-6-4s-6 3-6 4v1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12z"/>

          </svg>)

}



const TrashIcon = () => {

  return (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">

            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>

            <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>

          </svg>)

}



